import React from "react";
import { Box } from "@mui/material";
import { Home_bg_Body } from "../../client-api/ApiHomeBanner";
import { imagemain } from "../../client-api/ApiHome";
import HomeBanner1 from "./Fuel/HomeBanner1";
import { GetSubcategories } from "../../client-api/APIcategory";
import ProductGrid from "./Newdesignome/New1";
import Homeshopbycategory from "../HomeShopbycategory/Homeshopbycategory";
import WhyChooseUs from "../Newdesign/WhyChooseUs";
import OtherProductList from "../Productbycategory/Otherproducts";
import New2 from "./Newdesignome/New2";
import New3 from "./Newdesignome/New3";
import New4 from "./Newdesignome/New4";
import HomeHeroSlider from "./Newdesignome/HomeHeroSlider";
import Otherproducts from "../Productbycategory/Otherproducts";
import Listbrands from "../Brands/Listbrands";

export const secionimage =
  "https://admin.myfamilyfitness.com/public/uploads/section/images/";
const Home = () => {
  React.useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  const { data } = Home_bg_Body();
  const { datasubcategory } = GetSubcategories();
console.log(datasubcategory,"datasubcategory");
  return (
    <>
    <HomeHeroSlider/>

      <ProductGrid
        data={datasubcategory?.[0]?.sub_categories}
        name={"Fitness Indoor"}
      />
       <Homeshopbycategory />

      <New2
        data={datasubcategory?.[1]?.sub_categories}
        name={"Activities Outdoor"}
      />

      <OtherProductList />
      <New3
        data={datasubcategory?.[2]?.sub_categories}
        name={"Games & Sports"}
      />
       <New4
        data={datasubcategory?.[4]?.sub_categories}
        name={"Active Kids"}
      />
        <Listbrands />
        <WhyChooseUs /> 
      

    
    </>
  );
};

export default Home;
